export const SHOW_MESSAGE = 'app/Notification/SHOW_MESSAGE';
export const SHOW_ERROR = 'app/Notification/SHOW_ERROR';
export const CLOSE = 'app/Notification/CLOSE';
